import moment from "moment-timezone";
import React from "react";

import Button from "../../UI/Button";
import { HeaderAttribute, HeaderTitle, DownloadBtn, SquashedValues } from "../ReportsView";
import { toTitleCase } from "../../../utils/filters";

const XBARReportHeader = ({ reportData, toggleCommentBox }) => {
  const { clinician_name, dob, first_name, last_name, modified_at, patient_id, report_url, type } =
    reportData;

  const patientFullName = toTitleCase(first_name + " " + last_name);

  const localModifiedDateTime = moment
    .utc(modified_at, "MM/DD/YYYY HH:mm")
    .local()
    .format("MM/DD/YYYY hh:mm a");

  /** -----------
   * date of format `MM/DD/YYYY HH:mm:ss`
   * is split into ['MM/DD/YYYY','HH:mm:ss']
   */
  const splittedDate = localModifiedDateTime.split(" ");
  /** --------- */
  const LocaleModified_time = splittedDate[1] + " " + splittedDate[2];
  const LocaleModifiedDate = splittedDate[0];

  return (
    <div className="row no-gutters pb-3" style={{ borderBottom: "1px solid #B8B8B8" }}>
      {/* patient name */}
      <div className="col-12 mb-2">
        <HeaderTitle text={patientFullName} />
      </div>
      {/* report type */}
      <div className="col-12 mb-2">
        <HeaderAttribute
          attribute="Report Type"
          value={<SquashedValues valueList={[type, LocaleModifiedDate, LocaleModified_time]} />}
        />
      </div>
      {/* Clinician Name */}
      <div className="col-12 mb-2">
        <HeaderAttribute attribute="Clinician Name" value={clinician_name} />
      </div>
      {/* DOB */}
      <div className="col-12 col-lg-6 mb-2 mb-lg-0">
        <HeaderAttribute attribute="Date of Birth" value={dob} />
      </div>
      {/* header controls/actions */}
      <div className="col-12 col-lg-6 d-flex justify-content-lg-end">
        <div className="mr-2 mr-lg-3">
          <DownloadBtn url={report_url} />
        </div>
        <Button
          className="Btn fs-14 Btn--pri tw:font-light"
          onClick={toggleCommentBox}
          style={{ minHeight: "35px", padding: "4px 20px" }}
        >
          Add Provider Comment
        </Button>
      </div>
    </div>
  );
};

export default XBARReportHeader;
